<template>
    <select class="form-select form-control mb-2" v-model="selectedStatus">
        <option v-for="(item, index) in options" :key="index" :value="item.value">{{ item.label }}</option>
    </select>
    <div class="table-responsive">
        <table class="table table-bordered withdraw_table_sec" id="withdrawTable">
            <thead>
                <tr>
                    <th class="text-center">{{ $t('request-date', 'Request Date') }}</th>
                    <th class="text-center">{{ $t('payment-type', 'Payment Type') }}</th>
                    <th class="text-center">{{ $t('payment-method', 'Payment Method') }}</th>
                    <th class="text-center">{{ $t('requested-amount', 'Requested Amount') }}</th>
                    <th class="text-center">{{ $t('status', 'Status') }}</th>
                    <th class="text-center">{{ $t('approved-amount', 'Approved Amount') }}</th>
                    <th class="text-center">{{ $t('action-date', 'Action Date') }}</th>
                    <th class="text-center">{{ $t('transaction-no', 'Transaction No') }}</th>
                    <th class="text-center">{{ $t('reason', 'Reason') }}</th>
                    <th class="text-center">{{ $t('attachments', 'Attachments') }}</th>
                </tr>
            </thead>
            <tbody v-if="historyData && historyData.length > 0" class="withdrawTableData">
                <tr v-for="item in historyData" :key="item" class="text-center">
                    <td>
                        <span class="ms-1">
                            {{ $dateTime.getLocalDate(item?.created_at, 'DD/MM/YYYY hh:mm:ss A') }}
                        </span>
                    </td>
                    <td>{{ toTitleCaseWithSpaces(item?.type) }}</td>
                    <td >{{ item?.payment_method ?? '-' }}</td> 
                    <td>{{ item?.amount ? item?.amount : '-' }}</td>
                    <td>
                        <span class="depositStatus" :class="getTransactionStatus(item?.status)?.class">
                            {{ getTransactionStatus(item?.status)?.label }}
                        </span>
                        <i v-if="['pending', 'approve_in_process', 'reject_in_process','hold'].includes(item.status)" @click="getWalletHistory(item)"
                            :class="['fa', 'fa-refresh', {'fa-spin': selectedRequest?.c_a_tid == item?.c_a_tid?spinClass:false}]" aria-hidden="true"></i>
                    </td>
                    <td >{{  ['approve_completed'].includes(item.status) ? item?.approved_amount : '-'}}</td>
                    <td>
                        <span class="ms-1">
                            <template v-if="item?.action_at">
                                {{ $dateTime.sportItemDate(item.action_at, 'DD/MM/YYYY') }} | {{ $dateTime.sportItemDate(item.action_at, 'hh:mm A') }}
                            </template>
                            <template v-else-if="item?.hold_at && item.status == 'hold' ">
                                {{ $dateTime.sportItemDate(item.hold_at, 'DD/MM/YYYY') }} | {{ $dateTime.sportItemDate(item.hold_at, 'hh:mm A') }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </span>
                    </td> 
                    <td>{{ item?.transaction_id ?? '-' }}</td>
                    <td>{{ item.remark ? ShowNote(item.remark) : '-' }}</td>
                    <td class="wallet-view-btn-main" :class="{'tran-view-btn-sec': item.transaction_image_url}"> 
                        <button class="btn-tbl" type="button" :class="{'view-tran-btn12': item?.transaction_image_url}"  @click="item?.transaction_image_url && openTransactionDetails(item)">{{item.transaction_image_url ? $t('view-details', 'View Details') : '-'}}
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="10">
                        {{ $t('no-data-found', 'No Record Found ') }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <!--Attchement preview Modal -->
    <div class="modal fade" id="attchmentPreviewModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header modal_cmn_header">
                    <h5 class="modal-title">Details</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="qrPreview-image" v-if="transactionImageLists?.length">
                        <div class="transactionImage-item" v-for="(img, iIndex) in transactionImageLists" :key="iIndex">
                            <a :href="img" download target="_blank">
                            <img :src="img" height="100%" width="100px" />
                            </a>
                        </div>
                    </div>
                </div>
                <!-- <div class="searchbar-main deposit-page-close">
                    <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">Close</button>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { getWalletHistory, getTransactionStatus } from '../services/walletHistory';

export default {
    name: "WalletHistory",
    data() {
        return {
            formDates: {
                fromDate: '',
                toDate: '',
            },
            options: [
                { label: this.$t('all', 'All'), value: 'all', selected:true },
                { label: this.$t('pending', 'Pending'), value: 'pending', selected:true },
                { label: this.$t('approved', 'Approved'), value: 'approve_completed', selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 'reject_completed', selected:true },
                { label: this.$t('processing', 'Processing'), value: 'processing', selected:true },
                { label: this.$t('expired', 'Expired'), value: 'expired', selected:true },
            ],
            select_entries: 50,
            walletHistoryData: [],
            todayDate: new Date().toISOString().split('T')[0],
            spinClass: false,
            historyCallInterval: null,
            selectedStatus: 'all',
            currentImgLink: null,
            selectedRequest:null,
        }
    },
    props: ['filterType'],
    computed: {
        historyData() {
            if (this.selectedStatus == 'all') {
                return this.walletHistoryData
            } else if (this.selectedStatus == 'processing') {
                return this.walletHistoryData.filter(history =>
                    ['reject_in_process', 'approve_in_process','hold'].includes(history.status)
                );
            }
            return this.walletHistoryData.filter((history) => history.status == this.selectedStatus)
        },
        transactionImageLists() {
            return this.currentImgLink?.transaction_image_url?.split(',')
        },
    },
    mounted() {
        this.formDates.fromDate = this.$dateTime.getPreviousDate(30);
        this.formDates.toDate = this.$dateTime.getcurrentDate()
        this.getWalletHistory();
    },
    methods: {
        getTransactionStatus,
        ShowNote(txt) {
            if (txt == 'null' || txt == '' || txt == null)
                return '-';
            else
                return txt;
        },
        toTitleCaseWithSpaces(str) {
            return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        }, 
        async getWalletHistory(request  = null) {
            try{
                this.selectedRequest = request
                this.spinClass = true;
                let response = await getWalletHistory(this.formDates)
                setTimeout(()=>{this.spinClass = false;} ,500)
                if(response){
                    this.walletHistoryData = response?.walletHistoryData || [];
                }
            }catch(error){
                this.spinClass = false;
                console.log(error)
            }
        },
        fetchSelectedOptions() {
            let selectedOptions = [];
            this.options.forEach(opt => {
                if (opt.selected) {
                    selectedOptions.push(opt.value);
                }
            })
            return selectedOptions.join(',')
        },
        openTransactionDetails(item) {
            this.currentImgLink = item
            this.$helper.openModal('#attchmentPreviewModal')
        }
    }
}
</script>
